<!-- 支付记录，这个是否需要，其实在 Downloads 中已经有支付记录信息了。 -->
<template>
    <my-dialog ref="dialog" title="我的下载记录" :hide-callback="closeDialogCallback">
        <div ref='list-wrap' class="list-wrap">
            <el-table :data="deals" class="list-table" stripe show-header :size="tableSize" :empty-text="tableDesc">
                <el-table-column label="" :width="responsiveColumnWidth.thumbnailWidth" align="center">
                    <template slot-scope="scope">
                        <div style="display: flex; align-items: center">
                            <!-- BUG, 不能使用 lazy，否则关闭后再次打开 thumbnail 消失，目前原因不明-->
                            <!-- <el-image fit="fit" :src="scope.row.thumbnail" @click.native="popupEntity(scope.row.shortcode)" style="cursor:pointer"></el-image> -->
                            <sy-loading-image :src="scope.row.thumbnail"
                                              style-str="object-fit:cover;cursor:pointer;width:100%;height:100%"
                                              @click.native="popupEntity(scope.row.shortcode)">
                                <img slot="loading"
                                     style="object-fit:cover;cursor:pointer;width:100%;height:100%"
                                     :src="require('@/assets/transparent-gray_320x320.png')"/>
                            </sy-loading-image>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="金额" :width="responsiveColumnWidth.amountWidth" align="center">
                    <template slot-scope="scope">
                        <el-link :underline='false' @click="popupEntity(scope.row.shortcode)" style="font-size: inherit;">{{scope.row.amount}}</el-link>
                    </template>
                </el-table-column>
                <el-table-column label="支付方式" :width="responsiveColumnWidth.typeWidth" align="center">
                    <template slot-scope="scope">
                        <el-link :underline='false' @click="popupEntity(scope.row.shortcode)" style="font-size: inherit;">{{scope.row.type}}</el-link>
                        <div v-if="scope.row.type === '混合'" style="display:inline-block">
                            <el-tooltip class="item" effect="dark" :manual="true" :value="isShowMixInHelp" :content="scope.row.mixInHelp" placement="top">
                                <i class="iconfont icon-sy-question" style="font-size:14px" @click="showMixInHelp"></i>
                            </el-tooltip>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="下载日期" :width="responsiveColumnWidth.createDateWidth" align="center">
                    <template slot-scope="scope">
                        <el-link :underline='false' @click="popupEntity(scope.row.shortcode)" style="font-size: inherit;">{{scope.row.createDate}}</el-link>
                    </template>
                </el-table-column>
                <el-table-column label="有效期至" :width="responsiveColumnWidth.validToWidth" align="center">
                    <template slot-scope="scope">
                        <el-link :underline='false' @click="popupEntity(scope.row.shortcode)" style="font-size: inherit;">{{scope.row.validTo}}</el-link>
                    </template>
                </el-table-column>
                <el-table-column label="下载" :width="responsiveColumnWidth.downloadWidth" align="center">
                    <!-- 如果有效，显示进入 | 无效则显示过期-->
                    <template slot-scope="scope">
                        <!-- 备注，这里不能使用 el-link 组件，否则 overflow-elipsis 会失效 -->
                        <div v-if="scope.row.isValid">
                            <el-link :underline='false' @click="popupEntity(scope.row.shortcode)" style="font-size: inherit;">进入</el-link>
                        </div>
                        <div v-else class="font-gray">过期</div>
                    </template>
                </el-table-column>
            </el-table>
            <no-signal
                    v-if='noSignalVisible'
                    ref="noSignal"
                    :display-mode="noSignalDisplayMode"
                    :retry-handlers="[nextPage]"
                    :retry-basis="false"
                    :margin-top="0"></no-signal>
            <!-- mugen scroll 的注意事项参考 UserCommentTemplate.vue -->
            <mugen-scroll :handler="nextPage"
                          :handle-on-mount="false"
                          :should-handle="!loading && !isLastPage"
                          scroll-container="list-wrap" >
                <!-- 不要和全局的 loading 冲突 -->
                <loading :text="null" v-show="loading && !isLastPage"></loading>
            </mugen-scroll>
        </div>
        <popup-entity
            v-if="allowPopup"
            :z-index="20"
            :close-handler="closeHandler"
        />
    </my-dialog>
</template>

<script>
    import { DateFormat, GlobalLoading, isPhoneAgent, ShowEntityMode, Styles, errorMessage } from "../../../utils";
    import MyDialog from "../../commons/MyDialog";
    import PopupEntity from "../../entity/PopupEntity";
    import { Entity, Deal } from "../../../data/converter";
    import { loadDeals } from "../../../data/user";
    import MugenScroll from '@shangyang/vue-mugen-scroll'
    import { getEntity } from "../../../data/entity";
    import SyLoadingImage from "../../commons/SyLoadingImage";
    import { TimeoutError, NetworkError } from '@shangyang/error';

    export default {
        name: "UserDealHis",
        components: {
            MyDialog,
            PopupEntity,
            MugenScroll,
            SyLoadingImage
        },
        data(){
            return{
                deals: [],
                pageNum: 1,
                loading: false,
                isLastPage: false,
                allowPopup: false,
                noData: false,
                tableDesc: '数据加载中...',
                noSignalVisible: false,
                noSignalDisplayMode: 'vertical',
                isShowMixInHelp: false
            }
        },
        computed: {
            tableSize: function(){
                if(isPhoneAgent()){
                    return 'mini';
                }else{
                    return 'medium'
                }
            },
            /**
             * 原理参考 UserCommentsTempalte.vue 中的实现。
             * @return {{}}
             */
            responsiveColumnWidth: function(){
                const table_max_width = 620
                let maxWidth = window.innerWidth > 700 ? table_max_width : window.innerWidth - 20; // 20px is the padding size
                let rspvWidth = {}
                // 下面根据不同尺寸进行不同 responsive 比例的原因是，在大屏幕手机下，图片显得太小了。
                if(maxWidth <= 350 ){  // 超小屏幕的特有比例
                    rspvWidth = {
                        thumbnailWidth: parseInt(maxWidth * 0.15),
                        amountWidth: parseInt(maxWidth * 0.125),
                        typeWidth: parseInt(maxWidth * 0.20),
                        createDateWidth: parseInt(maxWidth * 0.20),
                        validToWidth: parseInt(maxWidth * 0.20),
                        downloadWidth: parseInt(maxWidth * 0.125)
                    }
                }else{  // 其它所有屏幕尺寸
                    rspvWidth = {
                        thumbnailWidth: parseInt(maxWidth * 0.25),
                        amountWidth: parseInt(maxWidth * 0.10),
                        typeWidth: parseInt(maxWidth * 0.15),
                        createDateWidth: parseInt(maxWidth * 0.195),
                        validToWidth: parseInt(maxWidth * 0.195),
                        downloadWidth: parseInt(maxWidth * 0.11)
                    }
                }
                console.log('responsive column with: ', JSON.stringify(rspvWidth, null, 4));
                return rspvWidth
            },
        },

        methods: {
            show(){
                // 延时显示
                setTimeout(()=>{
                    this.$refs.dialog.show();
                    // 因为二层弹窗 popup entity window 在默认关闭的时候会激活 body scroll，因此这里需要 lock.
                    Styles.bodyScrollLocked = true;
                }, 100); // 调整为 100ms 为适应 stickpop 的快速点击响应
                this.init();
                // HCF413 - repaint the rebought entity in user center deal page.（已过期再次购买刷新 user deal his）
                this.$EventBus.$on('bought', (deal) => {
                    console.log(`user deal his, the global bought event caught with ${deal}`);
                    deal = this.__convertDeal(Deal.convertDeal(deal));
                    this.deals.unshift(deal); // 追加到 deals head.
                });
            },

            // unlock the body scroll lock
            closeDialogCallback(){
                Styles.bodyScrollLocked = false;  // 解锁，注意上锁是在 this.show() 中进行的。
                this.$EventBus.$off('bought');
                console.log('user deal his, the global bought event is off');
            },

            init(){
                this.reset();
                // this.__mockData();
                this.$nextTick(()=>{
                    this.nextPage();
                })
            },

            reset(){
                this.tableDesc = '数据加载中...';
                this.noData = false;
                this.pageNum = 1;
                this.deals = [];
                this.loading = false;
                this.isLastPage = false;
                this.noSignalVisible = false; // 显示 no signal comp
            },

            async nextPage() {
                try {
                    this.loading = true;
                    let deals = await loadDeals(this.pageNum);
                    console.log(`user deal his, next page, load page ${this.pageNum} with deals ${JSON.stringify(deals, null, 4)}`);
                    if (deals === undefined || deals === null || deals.length === 0){
                        if (this.pageNum === 1){
                            this.tableDesc = '暂无数据'
                            this.noData = true;
                        } else {
                            this.isLastPage = true
                        }
                    } else {
                        for (let deal of deals) {
                            this.deals.push(this.__convertDeal(deal));
                        }
                        this.pageNum += 1;
                    }
                    this.noSignalVisible = false;
                }catch(error){
                    console.error(error);
                    // 如果是第一页就出现了网络异常，将其切换成 main page 异常。
                    if (error instanceof TimeoutError || error instanceof NetworkError) {
                        errorMessage(error.message);
                        this.noSignalVisible = true; // 显示 no signal comp
                        if (this.pageNum === 1){
                            this.noSignalDisplayMode = 'vertical'
                        } else { // page num > 1
                            this.noSignalDisplayMode = 'horizental'
                        }
                    }
                    this.tableDesc = '数据加载失败'
                }finally{
                    this.loading = false;
                }
            },

            async popupEntity(shortcode){
                try {
                    GlobalLoading.start();
                    let e = await getEntity(shortcode);
                    this.$store.commit('setShowEntityMode', ShowEntityMode.PopupPageMode);
                    // cache the popping up entity，注意：popup entity 就是从这里获取的 entity
                    this.$store.commit('setCurrentEntity', e);
                    this.allowPopup = true;
                } catch(error) {
                    console.error(error);
                    throw error;
                } finally {
                    GlobalLoading.stop();
                }
            },

            // conver the deal to display on the page.
            __convertDeal(deal){
                return {
                    shortcode: deal.shortcode,
                    thumbnail: deal.thumbnail,
                    amount: deal.total,
                    type: deal.paymentType,
                    mixInHelp: deal.mixInHelp, // 只有当混合（MIXIN）支付模式才会显示
                    createDate: DateFormat.responsiveYyMmDdFormat(deal.creatTs),
                    validTo: DateFormat.responsiveYyMmDdFormat(deal.validTo),
                    isValid: deal.isValid,
                }
            },

            // the close handle for the popup entity.
            closeHandler(){
                this.allowPopup = false;
            },

            __mockData(){
                // mock some test data there.
                this.deals.push({
                    thumbnail: 'http://dev.huocool.com.cn/e/9uwdiHrz2gX/2542813375580549891_thumbnail.jpg',
                    amount: 5,
                    type: '积分',
                    createDate: DateFormat.responsiveYyMmDdFormat(new Date),
                    validTo: DateFormat.responsiveYyMmDdFormat(new Date),
                    download: '下载'
                });
                this.deals.push({
                    thumbnail: 'http://dev.huocool.com.cn/e/9uwdiHrz2gX/2542813375580549891_thumbnail.jpg',
                    amount: '￥5',
                    type: 'ApplePay',
                    createDate: DateFormat.responsiveYyMmDdFormat(new Date),
                    validTo: DateFormat.responsiveYyMmDdFormat(new Date),
                    download: '过期'
                });
                this.deals.push({
                    thumbnail: 'http://dev.huocool.com.cn/e/9uwdiHrz2gX/2542813375580549891_thumbnail.jpg',
                    amount: '￥5',
                    type: '微信',
                    createDate: DateFormat.responsiveYyMmDdFormat(new Date),
                    validTo: DateFormat.responsiveYyMmDdFormat(new Date),
                    download: '过期'
                });
            },

            showMixInHelp(){
                this.isShowMixInHelp = true;
                setTimeout(()=>{
                    this.isShowMixInHelp = false;
                }, 2600)
            }
        }
    }
</script>

<style scoped>

    /* phone screen */
    @media (max-width: 540px) {
        /* 调整手机端 cell 两侧的 padding，默认是 10px 太大了 */
        /deep/ .el-table .cell {
            padding: 0 0px 0 0 !important;
        }

        /deep/ .el-table--mini td, .el-table--mini th  {
            padding: 2px 0 2px 0 !important;
        }

        /deep/ .el-dialog--center .el-dialog__body {
            padding: 2px 2px 2px 2px !important;
        }

        /deep/ .el-divider--horizontal {
            display: none !important;
        }

    }

    /*@media (min-width: 375px) and (max-width: 540px) {*/
    /*    !* 调整手机端 cell 两侧的 padding，默认是 10px 太大了 *!*/
    /*    /deep/ .el-table .cell{*/
    /*        padding: 0 0px 0 0px !important;*/
    /*    }*/

    /*    /deep/ .el-table--mini td, .el-table--mini th  {*/
    /*        padding: 2px 0 2px 0 !important;*/
    /*    }*/

    /*    /deep/ .el-dialog--center .el-dialog__body{*/
    /*        padding: 2px 2px 2px 2px !important;*/
    /*    }*/

    /*    /deep/ .el-divider--horizontal{*/
    /*        display: none !important;*/
    /*    }*/
    /*}*/

    /* 移动尺寸下，prev/next popupingEntity btn 不再显示 */
    /deep/ .el-image-viewer__next {
        display: none !important;
    }

    /deep/ .el-image-viewer__prev {
        display: none !important;
    }


</style>



// WEBPACK FOOTER //
// src/components/user/center/UserDealHis.vue